import React from "react";
import moment from "moment";
import McaStatusBadge from "./McaStatusBadge";
import { getEntityLabel } from "../../data/mcaEntities";

export const mcaProcessColumns = () => [
  {
    field: "name",
    headerName: "Process Name",
    width: 220,
  },
  {
    field: "triggerConfig.targetEntity",
    headerName: "Entity",
    width: 120,
    cellRender: (col, data) => getEntityLabel(data?.triggerConfig?.targetEntity),
  },
  {
    field: "triggerConfig.action",
    headerName: "Action",
    width: 100,
  },
  {
    field: "steps",
    headerName: "Steps",
    width: 80,
    cellRender: (col, data) => data?.steps?.length ?? 0,
  },
  {
    field: "status",
    headerName: "Status",
    width: 110,
    cellRender: (col, data) => <McaStatusBadge status={data?.status} />,
  },
  {
    field: "updatedAt",
    headerName: "Updated",
    width: 140,
    cellRender: (col, data) =>
      data?.updatedAt ? moment(data.updatedAt).format("YYYY-MM-DD HH:mm") : "",
  },
];

export const mcaRequestColumns = () => [
  {
    field: "code",
    headerName: "Request Code",
    width: 160,
  },
  {
    field: "targetEntity",
    headerName: "Entity",
    width: 120,
    cellRender: (col, data) => getEntityLabel(data?.targetEntity),
  },
  {
    field: "targetEntityCode",
    headerName: "Entity Code",
    width: 120,
  },
  {
    field: "action",
    headerName: "Action",
    width: 90,
  },
  {
    field: "maker",
    headerName: "Maker",
    width: 140,
    cellRender: (col, data) => data?.maker?.name ?? data?.maker?.cname ?? "",
  },
  {
    field: "currentStep",
    headerName: "Step",
    width: 80,
    cellRender: (col, data) =>
      data?.totalSteps
        ? `${(data.currentStep ?? 0) + 1}/${data.totalSteps}`
        : "",
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    cellRender: (col, data) => <McaStatusBadge status={data?.status} />,
  },
  {
    field: "createdAt",
    headerName: "Created",
    width: 140,
    cellRender: (col, data) =>
      data?.createdAt ? moment(data.createdAt).format("YYYY-MM-DD HH:mm") : "",
  },
];
